webpackJsonp([35783957827783],{

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(5);
	
	var _style = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventListItem = function EventListItem(_ref) {
	  var year = _ref.year,
	      position = _ref.position,
	      company = _ref.company;
	  return _react2.default.createElement(
	    _shared.ListItem,
	    null,
	    _react2.default.createElement(
	      _style.Wrapper,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'position' },
	        _react2.default.createElement(
	          _style.Position,
	          null,
	          position
	        ),
	        ' at ',
	        _react2.default.createElement(
	          'span',
	          null,
	          company
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'year' },
	        year
	      )
	    )
	  );
	};
	
	exports.default = EventListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Wrapper = exports.Position = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border-bottom: 1px dotted ', ';\n'], ['\n  border-bottom: 1px dotted ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  overflow: hidden;\n\n  div {\n    transition: transform .3s cubic-bezier(.45, 0, .1, 1);\n    will-change: transform;\n  }\n\n  .position {\n    transform: translateY(0);\n  }\n\n  .year {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    transform: translateY(100%);\n    color: #fff;\n  }\n\n  &:hover {\n    .position {\n      transform: translateY(-100%);\n    }\n\n    .year {\n      transform: translateY(0);\n    }\n  }\n'], ['\n  position: relative;\n  overflow: hidden;\n\n  div {\n    transition: transform .3s cubic-bezier(.45, 0, .1, 1);\n    will-change: transform;\n  }\n\n  .position {\n    transform: translateY(0);\n  }\n\n  .year {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    transform: translateY(100%);\n    color: #fff;\n  }\n\n  &:hover {\n    .position {\n      transform: translateY(-100%);\n    }\n\n    .year {\n      transform: translateY(0);\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Position = exports.Position = _styledComponents2.default.span(_templateObject, _constants.colors.gray700);
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject2);

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(153);
	
	var _shared = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSection = function ImageSection(_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(_style.StyledImage, {
	      src: "/images/profile/dmf-72.jpg",
	      alt: "Background Image",
	      className: "img1",
	      sources: [{
	        srcset: ["/images/profile/dmf-72.jpg 1x", "/images/profile/dmf-72.jpg 2x"]
	      }]
	    }),
	    _react2.default.createElement(_style.StyledImage, {
	      src: "/images/profile/dmf-4.jpg",
	      alt: "Background Image",
	      className: "img1",
	      sources: [{
	        srcset: ["/images/profile/dmf-4.jpg 1x", "/images/profile/dmf-4.jpg 2x"]
	      }]
	    }),
	    _react2.default.createElement(_style.StyledImage, {
	      src: "/images/profile/dmf-93.jpg",
	      alt: "Background Image",
	      className: "img3",
	      sources: [{
	        srcset: ["/images/profile/dmf-93.jpg 1x", "/images/profile/dmf-93.jpg 2x"]
	      }]
	    })
	  );
	};
	
	exports.default = ImageSection;
	module.exports = exports["default"];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InfoWrapper = exports.StyledImage = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n  width: 100%;\n  ", "\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n  width: 100%;\n  ", "\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 3rem;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  "], ["\n  padding: 3rem;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n     padding: 1.5rem; \n  "], ["\n     padding: 1.5rem; \n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  /* grid-row: span 3;\n  grid-column: span 4;\n  background: ", ";\n  position: relative;\n  overflow: hidden;*/\n  outline: 1px rgba(255, 255, 255, 0.5) solid;\n\n  &.img1 {\n    /* grid-row: span 2; */\n  }\n\n  &.img2 {\n    /* grid-row: span 2; */\n    ", "\n  }\n  &.img3 {\n    grid-column: span 2;\n    ", "\n  }\n\n  img {\n    width: 100%;\n    object-fit: cover;\n    ", "\n  }\n\n  ", "\n  ", "\n"], ["\n  /* grid-row: span 3;\n  grid-column: span 4;\n  background: ", ";\n  position: relative;\n  overflow: hidden;*/\n  outline: 1px rgba(255, 255, 255, 0.5) solid;\n\n  &.img1 {\n    /* grid-row: span 2; */\n  }\n\n  &.img2 {\n    /* grid-row: span 2; */\n    ", "\n  }\n  &.img3 {\n    grid-column: span 2;\n    ", "\n  }\n\n  img {\n    width: 100%;\n    object-fit: cover;\n    ", "\n  }\n\n  ", "\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    /* grid-row: span 1; */\n  "], ["\n    /* grid-row: span 1; */\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    grid-column: span 1;\n  "], ["\n    grid-column: span 1;\n  "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    "], ["\n    "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  \n  "], ["\n  \n  "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  /* grid-column: span 8; */\n    \n    &:before {\n      /* padding-top: 100%; */\n    }\n  "], ["\n  /* grid-column: span 8; */\n    \n    &:before {\n      /* padding-top: 100%; */\n    }\n  "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  /* grid-row: 5 / 5;\n  grid-column: 2 / 6;\n  z-index: 3;\n  align-self: center; */\n  ", "\n  ", "\n"], ["\n  /* grid-row: 5 / 5;\n  grid-column: 2 / 6;\n  z-index: 3;\n  align-self: center; */\n  ", "\n  ", "\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  /* grid-row: 5 / 6;\n    grid-column: 1 / 5;\n    align-self: end; */\n  "], ["\n  /* grid-row: 5 / 6;\n    grid-column: 1 / 5;\n    align-self: end; */\n  "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n    \n    /* padding: 0 2rem; */\n  "], ["\n    \n    /* padding: 0 2rem; */\n  "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject3));
	
	var StyledImage = exports.StyledImage = (0, _styledComponents2.default)(_Image2.default)(_templateObject4, _constants.colors.blue900, _constants.media.md(_templateObject5), _constants.media.md(_templateObject6), _constants.media.sm(_templateObject7), _constants.media.md(_templateObject8), _constants.media.sm(_templateObject9));
	
	var InfoWrapper = exports.InfoWrapper = _styledComponents2.default.header(_templateObject10, _constants.media.md(_templateObject11), _constants.media.sm(_templateObject12));

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  position: absolute;\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  max-width: 28rem;\n  inset: 0;\n  margin-top: 10rem;\n"], ["\n  ", "\n  position: absolute;\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  max-width: 28rem;\n  inset: 0;\n  margin-top: 10rem;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AudioPlayer = __webpack_require__(40);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _style = __webpack_require__(61);
	
	var _shared = __webpack_require__(5);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sub = _styledComponents2.default.h1(_templateObject, (0, _constants.getOuterSpace)("padding"));
	
	var ProfileIntroSection = function ProfileIntroSection(_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(
	      _style.InfoWrapper,
	      null,
	      _react2.default.createElement(
	        Sub,
	        null,
	        "Poems and myths set ",
	        _react2.default.createElement("br", null),
	        "into musical motion."
	      ),
	      _react2.default.createElement(_AudioPlayer2.default, {
	        fixed: false,
	        streamUrl: "/audio/ChildandWattleTree.m4a",
	        trackTitle: "'Child and Wattle Tree'"
	      }),
	      _react2.default.createElement(
	        _style.Content,
	        null,
	        content()
	      )
	    ),
	    _react2.default.createElement(_style.StyledImage, {
	      src: "/images/background/nau-back-01.jpg",
	      alt: "Background Image",
	      loader: function loader(_ref2) {
	        var isLoaded = _ref2.isLoaded;
	        return _react2.default.createElement(_shared.Loader, { isLoaded: isLoaded });
	      },
	      sources: [{
	        srcset: ["/images/backgrsound/nau-back-01.jpg 1x", "/images/background/nau-back-01@2x.jpg 2x"]
	      }]
	    })
	  );
	};
	
	exports.default = ProfileIntroSection;
	module.exports = exports["default"];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Content = exports.InfoWrapper = exports.StyledImage = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  position: relative;\n  height: 100vh;\n  height: 100lvh;\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  position: relative;\n  height: 100vh;\n  height: 100lvh;\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 3rem;\n  "], ["\n  padding: 3rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(5, 1fr);\n    padding: 1.5rem;\n  "], ["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(5, 1fr);\n    padding: 1.5rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  grid-area: 1 / 1 / -1 / -1;\n  background: ", ";\n  position: relative;\n  overflow: hidden;\n  margin: -1rem;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    mix-blend-mode: lighten;\n    opacity: 0.5;\n    display: block;\n    object-fit: cover;\n    object-position: bottom;\n    z-index: 2;\n    ", "\n  }\n\n  ", "\n  ", "\n"], ["\n  grid-area: 1 / 1 / -1 / -1;\n  background: ", ";\n  position: relative;\n  overflow: hidden;\n  margin: -1rem;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    mix-blend-mode: lighten;\n    opacity: 0.5;\n    display: block;\n    object-fit: cover;\n    object-position: bottom;\n    z-index: 2;\n    ", "\n  }\n\n  ", "\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n      opacity: .6;\n    "], ["\n      opacity: .6;\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  margin: -3rem;\n  "], ["\n  margin: -3rem;\n  "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  margin: -1.5rem;\n    grid-area: 1 / 5 / 6 / 1;\n    &:before {\n      padding-top: 100%;\n    }\n  "], ["\n  margin: -1.5rem;\n    grid-area: 1 / 5 / 6 / 1;\n    &:before {\n      padding-top: 100%;\n    }\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  grid-row: 5 / 5;\n  grid-column: 2 / 6;\n  z-index: 3;\n  align-self: center;\n  ", "\n  ", "\n"], ["\n  grid-row: 5 / 5;\n  grid-column: 2 / 6;\n  z-index: 3;\n  align-self: center;\n  ", "\n  ", "\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  grid-row: 5 / 6;\n    grid-column: 1 / 5;\n    align-self: center;\n  "], ["\n  grid-row: 5 / 6;\n    grid-column: 1 / 5;\n    align-self: center;\n  "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  align-self: start;\n\n    /* padding: 0 2rem; */\n  "], ["\n  align-self: start;\n\n    /* padding: 0 2rem; */\n  "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  margin-top: 1rem;\n  line-height: 1.8em;\n  color: ", ";\n  ", "\n\n  h1 {\n    font-weight: 400;\n  }\n\n  p {\n    margin: 1.5rem 0;\n  }\n\n  a {\n    color: #fff;\n    border-bottom: 1px dotted ", ";\n\n    &:hover {\n      border-bottom-color: ", ";\n    }\n  }\n"], ["\n  margin-top: 1rem;\n  line-height: 1.8em;\n  color: ", ";\n  ", "\n\n  h1 {\n    font-weight: 400;\n  }\n\n  p {\n    margin: 1.5rem 0;\n  }\n\n  a {\n    color: #fff;\n    border-bottom: 1px dotted ", ";\n\n    &:hover {\n      border-bottom-color: ", ";\n    }\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n    margin-top: 1rem;\n  "], ["\n    margin-top: 1rem;\n  "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject3));
	
	var StyledImage = exports.StyledImage = (0, _styledComponents2.default)(_Image2.default)(_templateObject4, _constants.colors.blue900, _constants.media.sm(_templateObject5), _constants.media.md(_templateObject6), _constants.media.sm(_templateObject7));
	
	var InfoWrapper = exports.InfoWrapper = _styledComponents2.default.header(_templateObject8, _constants.media.md(_templateObject9), _constants.media.sm(_templateObject10));
	
	var Content = exports.Content = _styledComponents2.default.main(_templateObject11, _constants.colors.gray500, _constants.media.sm(_templateObject12), _constants.colors.gray500, _constants.colors.red500);

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileList = function ProfileList(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      list = _ref.list,
	      className = _ref.className;
	  return _react2.default.createElement(
	    "article",
	    { className: className },
	    _react2.default.createElement(
	      "header",
	      null,
	      _react2.default.createElement(
	        _style.ListTitle,
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        _style.SubTitle,
	        null,
	        subtitle
	      )
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      list()
	    )
	  );
	};
	
	exports.default = ProfileList;
	module.exports = exports["default"];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.StyledImage = exports.NewList = exports.SubTitle = exports.ListTitle = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n\n  &::after {\n    content: \"\";\n    width: 1rem;\n    height: 1px;\n    background: ", ";\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 1rem;\n  }\n"], ["\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n\n  &::after {\n    content: \"\";\n    width: 1rem;\n    height: 1px;\n    background: ", ";\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 1rem;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n  text-decoration: underline;\n"], ["\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n  text-decoration: underline;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  .tbg {\n    grid-column: 2 / span 3;\n    grid-row-start: 3;\n    img {\n      width: 100%;\n    }\n    ", "\n  }\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  position: relative;\n  height: 60vh;\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n  article {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    grid-column: 2 / span 2;\n    grid-row: 3 / 4;\n    h1 {\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n    }\n    p {\n      margin-bottom: 1rem;\n    }\n    a {\n      text-decoration: underline;\n      color: white;\n    }\n    &:first-of-type {\n      grid-column: 5 / span 2;\n    }\n    ", "\n    ", "\n  }\n"], ["\n  .tbg {\n    grid-column: 2 / span 3;\n    grid-row-start: 3;\n    img {\n      width: 100%;\n    }\n    ", "\n  }\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  position: relative;\n  height: 60vh;\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n  article {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    grid-column: 2 / span 2;\n    grid-row: 3 / 4;\n    h1 {\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n    }\n    p {\n      margin-bottom: 1rem;\n    }\n    a {\n      text-decoration: underline;\n      color: white;\n    }\n    &:first-of-type {\n      grid-column: 5 / span 2;\n    }\n    ", "\n    ", "\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    grid-row-start: 1;\n    grid-column: 1 / span 4;\n  "], ["\n    grid-row-start: 1;\n    grid-column: 1 / span 4;\n  "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    padding: 3rem;\n    height: auto;\n    grid-template-rows: auto;\n  "], ["\n    padding: 3rem;\n    height: auto;\n    grid-template-rows: auto;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: auto;\n    padding: 1.5rem;\n    height: auto;\n  "], ["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: auto;\n    padding: 1.5rem;\n    height: auto;\n  "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n      grid-template-rows: auto;\n      grid-row: 1 / 2;\n      grid-column: 1 / span 3;\n      &:first-of-type {\n       grid-column: 5 / span 3;\n      }\n    "], ["\n      grid-template-rows: auto;\n      grid-row: 1 / 2;\n      grid-column: 1 / span 3;\n      &:first-of-type {\n       grid-column: 5 / span 3;\n      }\n    "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n    &:first-of-type {\n       grid-column: 1 / span 4;\n       grid-row: 2 / 2;\n      }\n  "], ["\n    &:first-of-type {\n       grid-column: 1 / span 4;\n       grid-row: 2 / 2;\n      }\n  "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  grid-area: 1 / 3 / 5 / 9;\n  position: relative;\n  overflow: hidden;\n  margin: -1rem;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    display: block;\n    object-fit: contain;\n    object-position: center;\n    z-index: 2;\n    ", "\n  }\n\n  ", "\n  ", "\n"], ["\n  grid-area: 1 / 3 / 5 / 9;\n  position: relative;\n  overflow: hidden;\n  margin: -1rem;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    display: block;\n    object-fit: contain;\n    object-position: center;\n    z-index: 2;\n    ", "\n  }\n\n  ", "\n  ", "\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n\n    "], ["\n\n    "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  margin: -3rem;\n  "], ["\n  margin: -3rem;\n  "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  margin: -1.5rem;\n    grid-area: 1 / 5 / 4 / 1;\n    &:before {\n      padding-top: 100%;\n    }\n  "], ["\n  margin: -1.5rem;\n    grid-area: 1 / 5 / 4 / 1;\n    &:before {\n      padding-top: 100%;\n    }\n  "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ListTitle = exports.ListTitle = _styledComponents2.default.h2(_templateObject, _constants.colors.red500);
	var SubTitle = exports.SubTitle = _styledComponents2.default.h3(_templateObject2);
	var NewList = exports.NewList = _styledComponents2.default.div(_templateObject3, _constants.media.md(_templateObject4), _constants.media.md(_templateObject5), _constants.media.sm(_templateObject6), _constants.media.md(_templateObject7), _constants.media.sm(_templateObject8));
	
	var StyledImage = exports.StyledImage = (0, _styledComponents2.default)(_Image2.default)(_templateObject9, _constants.media.sm(_templateObject10), _constants.media.md(_templateObject11), _constants.media.sm(_templateObject12));

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileListItem = function ProfileListItem(_ref) {
	  var name = _ref.name,
	      url = _ref.url;
	  return _react2.default.createElement(
	    _shared.ListItem,
	    null,
	    url ? _react2.default.createElement(
	      "a",
	      { href: url, target: "_blank", rel: "noopener noreferrer" },
	      name
	    ) : name
	  );
	};
	
	exports.default = ProfileListItem;
	module.exports = exports["default"];

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.homeQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: auto;\n  position: relative;\n  grid-gap: 1rem;\n  padding: 8rem 1rem 8rem 1rem;\n  ", "\n  ", "\n  .upcoming li {\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n    border-bottom: 1px solid ", ";\n  }\n  .text {\n    grid-column: 2 / 5;\n    grid-row: 1 / 2;\n    ", "\n    ", "\n    h1 {\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n      max-width: 18rem;\n    }\n    p {\n      margin-bottom: 1rem;\n    }\n    a {\n      text-decoration: underline;\n    }\n  }\n  .quote {\n    grid-row: 1;\n    grid-column: 6 / 8;\n    font-size: 1.6rem;\n    line-height: 1.1;\n    ", "\n    ", "\n\n    .byline {\n      font-size: 0.8rem;\n      margin-top: 1rem;\n    }\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: auto;\n  position: relative;\n  grid-gap: 1rem;\n  padding: 8rem 1rem 8rem 1rem;\n  ", "\n  ", "\n  .upcoming li {\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n    border-bottom: 1px solid ", ";\n  }\n  .text {\n    grid-column: 2 / 5;\n    grid-row: 1 / 2;\n    ", "\n    ", "\n    h1 {\n      font-size: 1.3rem;\n      margin-bottom: 1rem;\n      max-width: 18rem;\n    }\n    p {\n      margin-bottom: 1rem;\n    }\n    a {\n      text-decoration: underline;\n    }\n  }\n  .quote {\n    grid-row: 1;\n    grid-column: 6 / 8;\n    font-size: 1.6rem;\n    line-height: 1.1;\n    ", "\n    ", "\n\n    .byline {\n      font-size: 0.8rem;\n      margin-top: 1rem;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 3rem;\n  "], ["\n  padding: 3rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(1, 1fr);\n    padding: 1.5rem;\n  "], ["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(1, 1fr);\n    padding: 1.5rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      grid-column: 1 / 5;\n    "], ["\n      grid-column: 1 / 5;\n    "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n      grid-row: 2 / 2;\n    "], ["\n      grid-row: 2 / 2;\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n      font-size: 1.4rem;\n      grid-column: 5 / 9;\n    "], ["\n      font-size: 1.4rem;\n      grid-column: 5 / 9;\n    "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n      grid-row: 1;\n      grid-column: 1 / 5;\n      font-size: 1.4rem;\n    "], ["\n      grid-row: 1;\n      grid-column: 1 / 5;\n      font-size: 1.4rem;\n    "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProfileIntroSection = __webpack_require__(60);
	
	var _ProfileIntroSection2 = _interopRequireDefault(_ProfileIntroSection);
	
	var _ProfileList = __webpack_require__(62);
	
	var _ProfileList2 = _interopRequireDefault(_ProfileList);
	
	var _ProfileListItem = __webpack_require__(63);
	
	var _ProfileListItem2 = _interopRequireDefault(_ProfileListItem);
	
	var _EventListItem = __webpack_require__(58);
	
	var _EventListItem2 = _interopRequireDefault(_EventListItem);
	
	var _ImageSection = __webpack_require__(152);
	
	var _ImageSection2 = _interopRequireDefault(_ImageSection);
	
	var _Head = __webpack_require__(30);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _constants = __webpack_require__(4);
	
	var _constants2 = __webpack_require__(31);
	
	var _shared = __webpack_require__(5);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _style = __webpack_require__(41);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	/* stylelint-disable */
	var ListsSection = _styledComponents2.default.section(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject3), _constants.colors.gray700, _constants.media.md(_templateObject4), _constants.media.sm(_templateObject5), _constants.media.md(_templateObject6), _constants.media.sm(_templateObject7));
	
	/* stylelint-enable */
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var clients = data.clients,
	      events = data.events,
	      mentions = data.mentions,
	      articles = data.articles;
	
	
	  return _react2.default.createElement(
	    _shared.ContentWrapper,
	    null,
	    _react2.default.createElement(_Head2.default, _extends({}, _constants2.META.profile, { image: _constants2.META.common.image })),
	    _react2.default.createElement(_ProfileIntroSection2.default, { content: function content() {
	        return _react2.default.createElement(_react.Fragment, null);
	      } }),
	    _react2.default.createElement(
	      "a",
	      { href: "/the-burning-glass" },
	      _react2.default.createElement(
	        _style.NewList,
	        null,
	        _react2.default.createElement(_Image2.default, {
	          src: "/images/the-burning-glass-bg/tgb_bg.webp",
	          alt: "The Burning Glass - Singles",
	          className: "tbg",
	          sources: [{
	            srcset: ["/images/the-burning-glass-bg/tbg_bg.avif 1x", "/images/the-burning-glass-bg/tbg_bg@2x.avif 2x", "/images/the-burning-glass-bg/tbg_bg.webp 1x", "/images/the-burning-glass-bg/tbg_bg@2x.webp 2x", "/images/the-burning-glass-bg/tbg_bg.jpg 1x", "/images/the-burning-glass-bg/tbg_bg@2x.jpg 2x"]
	          }]
	        }),
	        _react2.default.createElement(_ProfileList2.default, {
	          title: "Preview 3 songs from the upcoming album 'The Burning Glass':",
	          subtitle: "More info",
	          list: function list() {
	            return clients.edges.map(function (_ref2, i) {
	              var client = _ref2.client;
	              return _react2.default.createElement(_ProfileListItem2.default, _extends({ key: i }, client));
	            });
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      ListsSection,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "text" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Nausicaa has performed alongside the likes of Tiny Ruins, Angie Hart (Frente) and Ben Salter and premiered works at Dark Mofo, the Woodford Folk Festival, and the Queensland Poetry Festival."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The brainchild of Simon Munro, Nausicaa grew out of his work as an arts producer with poetry/music project",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://borrowedverse.com",
	              target: "_blank",
	              rel: "noopener noreferrer"
	            },
	            "Borrowed Verse"
	          ),
	          ". Prior to creating Nausicaa, Munro released four solo albums under the alias Alex Bell."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "events" },
	          _react2.default.createElement(
	            "div",
	            { className: "upcoming" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Events"
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Upcoming"
	            ),
	            _react2.default.createElement(
	              "ul",
	              null,
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Dates TBA soon!"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "past" },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Past"
	            ),
	            _react2.default.createElement(
	              "ul",
	              null,
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Nausica\xE4 + Black Square String Quartet: ",
	                  _react2.default.createElement("br", null),
	                  "Judith Wright in Song"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Holy Trinity, Fortitude Valley ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Friday, 14 November 2025. 7pm"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Nausica\xE4 + Black Square String Quartet ",
	                  _react2.default.createElement("br", null),
	                  "Judith Wright in Song"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Zamia Theatre. Mount Tamborine, Queensland ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Saturday, 15 November 2025. 7pm"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://www.stickytickets.com.au/lgop9/nausicaa_judith_wright_in_song_w_lily_morris.aspx",
	                      target: "_blank"
	                    },
	                    "Nausica\xE4: Judith Wright in Song w/ Lily Morris"
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Braidwood Regional Arts Group. Braidwood NSW ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Friday, 7 November 2025"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://www.stickytickets.com.au/3habx/nausicaa_judith_wright_in_song_w_jhana_allan.aspx",
	                      target: "_blank"
	                    },
	                    "Nausica\xE4: Judith Wright in Song w/ Jhana Allan"
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "McCrossins Mill, Uralla NSW ",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Sunday, 2 November 2025"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Dark Mofo 2018"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Borrowed Verse w/ Tiny Ruins, Ben Salter, Angie Hart, Emily Lubitz (Tinpan Orange), David Stavanger, Graham Akhurst"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Woodford Folk Festival"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Borrowed Verse w/ Tom Cooney, The Stress of Leisure"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Queensland Poetry Festival"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Borrowed Verse w/ Ben Salter, Graham Akhurst"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Two Fires Festival"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Braidwood, NSW"
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "quote" },
	        "\u201C\u2026Equal parts Paul Simon and Nick Drake. It\u2019s wonderful, beautiful\u2026\u201D",
	        _react2.default.createElement(
	          "div",
	          { className: "byline" },
	          "David Faulkner \u2014 The Saturday Paper "
	        )
	      )
	    ),
	    _react2.default.createElement(_ImageSection2.default, null)
	  );
	};
	
	var homeQuery = exports.homeQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e832beee175883736bc5.js